export class ApiFetch {
    constructor(hostWithScheme) {
        this.hostWithScheme = hostWithScheme;
    }

    post(path, data) {
        return new Promise((resolve, reject) => {
                let headers = new Headers;
                headers.append("Content-Type", "application/json");

                let request = {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(data)
                };

                fetch(this.hostWithScheme + path, request)
                    .then(r => r.json())
                    .then(r => resolve(r))
                    .catch(error => reject(error))
            }
        );
    }
}